/*
 * The main JavaScript file.
 */


/**
 * Frameworks and plugins.
 */
import './workarounds/workarounds.js';
import 'idempotent-babel-polyfill';
import { jqueryeasing } from 'jquery.easing/jquery.easing.1.3.min.js';
import { isotope } from 'isotope-layout/dist/isotope.pkgd.min.js';
import { flexslider } from 'flexslider/jquery.flexslider-min.js';
import 'remove-focus-outline';



/**
 * Polyfills.
 */
import { CSSVariables } from './polyfills/css-variables/css-variables.js';



/**
 * Generic functionality.
 */
import { BrowserDetection } from './browserdetection/browserdetection.js';



/**
 * Module functionality.
 */
import { GoogleMaps } from './modules/google-maps/google-maps.js';
import { Header } from './modules/header/header.js';
import { Hero } from './modules/hero/hero.js';
import { Media } from './modules/media/media.js';
import { SubHero } from './modules/sub-hero/sub-hero.js';
import { Search } from './modules/header/search.js';



/**
 * Theme functionality.
 */
import { Theming } from './theming/theming.js';



/**
 * Runtime.
 */

// Set a global variable to handle our app data
if ( typeof window.app === 'undefined' )
{
	window.app = {};
}

if ( typeof window.app.init === 'undefined' )
{
	window.app.init = {};
}

// Define all the functions we want to run on initiation but don't actually run them as this is donw in the child theme
window.app.init.wisesite =
{
	'browserDetection' :
	() =>
	{
		// Instantiate a new browser detection object available globally
		window.app.BrowserDetection = new BrowserDetection();

		// Run browser detection
		window.app.BrowserDetection.detect();
	},
	'header' :
	() =>
	{
		// Instantiate a new header object available globally
		window.app.Header = new Header();

		// Add event listeners
		window.app.Header.addListeners();
	},
	'hero'       : Hero.addListeners,
	'googlemaps' : GoogleMaps.addListeners,
	'search'     : Search.addListeners,
	'subhero'    : SubHero.addListeners,
	'media'      : Media.addListeners,
	'theming'    :
	() =>
	{
		// Handle logo sizing
		Theming.logoSizeHandler();

		// Handle window resizing
		Theming.resizeHandler();
	},
	'polyfills'  :
	() =>
	{
		CSSVariables.addListeners();
	}
};



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/main.js